export default {
  methods: {
    setDirectorName(director) {
      const f = director.last_name;
      const i = director.first_name[0] + ".";
      const o = director.fathers_name[0] + ".";
      return f + " " + i + " " + o;
    }
  }
};
